<template>
  <List />
</template>

<script>
import List from './comp.vue';

export default {
  provide() {
    return {
      listMode: 'group'
    };
  },
  components: {
    List
  }
};
</script>
